import type {ReactAction} from '@netx/core/bootstrap';
import {faArrowUpFromBracket} from '@netx/core-icons';
import {appRouter} from '@netx/core-next/instance/router';
import {
	canManageUploadAssetRequests,
	uploadAssetRequestEnabled,
} from '../enablers';
import {UploadAssetRequestsManageLabel} from '../locales';
import {UploadAssetRequestManagerRoute} from '../routes';

export const uploadAssetRequestActionRequestsManageRouteIcon =
	faArrowUpFromBracket;

/**
 * Route to upload requests management
 * @param params
 * @returns Action
 */
export const uploadAssetRequestActionRequestsManageRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'upload-asset-requests-manager-route',
	cb: () => appRouter.navigate(UploadAssetRequestManagerRoute.BASE, true),
	enableTest: () =>
		canManageUploadAssetRequests() && uploadAssetRequestEnabled(),
	icon: uploadAssetRequestActionRequestsManageRouteIcon,
	get label() {
		return UploadAssetRequestsManageLabel.ROUTE;
	},
	routeMatch: /^assets\/requests(\/?)/,
	...params,
});
